import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import { Icon } from '@iconify/react';
import useEmpaquetado from '../../../../../hooks/useEmpaquetado';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import SelectOptionLayout, { SideItem } from '../../../../../layouts/components/SelectOptionLayout';
import ListaProductos from './section-1/ListaEmpaque';
import ListaTraspasos from './section-2/ListaTraspasos';
import { firestore } from '../../../../../contexts/FirebaseContext';
import useEmpaque from '../../../../../hooks/useEmpaque';
import useUserRole from '../../../../../hooks/useUserRole';
import { useSnackbar } from 'notistack';

export default function DialogAlmacenLicen() {
  const [almacenUser, setAlmacenUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const { currentUser, currentHostUser } = useAuthUsers();
  const { inicializarAlmacen } = useEmpaque();
  const { admitByRoleName } = useUserRole();
  const { enqueueSnackbar } = useSnackbar();

  const userToUse = admitByRoleName(['cajero']) ? currentHostUser : currentUser;

  const initializeAlmacenUser = async () => {
    await inicializarAlmacen(userToUse.id);
  };

  useEffect(() => {
    function getData() {
      firestore
        .collection('emp_almacenes')
        .doc(userToUse.almacenId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setAlmacenUser({ id: doc.id, ...doc.data() });
            setLoading(false);
          } else {
            setLoading(false);
          }
        });
    }

    if (userToUse?.almacenId) {
      getData();
    }
  }, [userToUse.almacenId]);

  return (
    <Box>
      {loading && !almacenUser && <CircularProgress />}
      {!loading && almacenUser && (
        <Button
          variant="contained"
          size="large"
          color="primary"
          startIcon={<Icon icon="eva:inbox-fill" />}
          onClick={() => setOpenDialog(true)}
        >
          Abrir almacen
        </Button>
      )}
      {!loading && !almacenUser && (
        <Button
          onClick={async () => {
            if (admitByRoleName(['plus', 'lite', 'basic', 'almighty'])) {
              await initializeAlmacenUser();
            } else {
              enqueueSnackbar('Solo el lienciatario puede inicializar un almacen.', { variant: 'error' });
            }
          }}
          variant="contained"
          color="secondary"
          size="large"
        >
          Inicializar almacen
        </Button>
      )}
      {/* {!loading && almacenUser ? (
        <Button
          variant="contained"
          color="info"
          startIcon={<Icon icon="eva:inbox-fill" />}
          onClick={() => setOpenDialog(true)}
        >
          Abrir almacen
        </Button>
      ) : (
        <Button onClick={initializeAlmacenUser} variant="contained" color="primary">
          Inicializar almacen
        </Button>
      )} */}
      <DialogBody open={openDialog} onClose={setOpenDialog} userData={userToUse} />
    </Box>
  );
}

function DialogBody({ open, onClose, userData }) {
  const [section, setSection] = useState(1);

  const handleClose = () => {
    onClose(false);
  };

  const side = (
    <>
      <SideItem text="Inventario actual" section={1} action={setSection} icon={<Icon icon="eva:inbox-fill" />} />
      <SideItem text="Traspasos" section={2} action={setSection} icon={<Icon icon="eva:inbox-fill" />} />
    </>
  );

  const body = (
    <>
      {section === 1 && (
        <Grid item xs={12}>
          <ListaProductos userData={userData} />
        </Grid>
      )}
      {section === 2 && (
        <Grid item xs={12}>
          <ListaTraspasos userData={userData} />
        </Grid>
      )}
    </>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Empaque</DialogTitle>
      <DialogContent sx={{ marginTop: '15px' }}>
        <SelectOptionLayout sidebar={side} body={body} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
